export const BREAKPOINTS = {
  PHONE: 480,
  TABLET: 768,
  DESKTOP: 1024,
  LARGEDESKTOP: 1440,
};
